import React from 'react';
// This context remembers information about the tenant and other relevant information about the order history page
const OrderHistoryContext = React.createContext();

export const OrderHistoryProvider = OrderHistoryContext.Provider;
export const OrderHistoryConsumer = OrderHistoryContext.Consumer;

export default OrderHistoryContext;
